import { Routes } from '@angular/router';
import {
  BreadCrumbRouteConfig,
  RenderInterfaceGuard,
  Utils
} from 'viggo-sistemas-core-web';

export const routesAdminDadosEmpresa: Routes = [
  {
    path: 'dados-empresa',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@app/modules/dados-empresa/dados-empresa.module').then(
        m => m.DadosEmpresaModule
      ),
    data: {
      module: 'EMPRESA_DADOS',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'EMPRESA'),
      breadcrumb: {
        label: 'Editando informações da empresa',
        icon: 'pi pi-fw pi-pencil'
      } as BreadCrumbRouteConfig
    }
  },
  {
    path: 'dados-fiscais',
    canActivate: [RenderInterfaceGuard],
    loadChildren: () =>
      import('@app/modules/dados-empresa/dados-empresa.module').then(
        m => m.DadosEmpresaModule
      ),
    data: {
      module: 'EMPRESA_DADOS_FISCAIS',
      breadcrumbMenu: Utils.getBreadcrumbMenu('CONFIGURACOES', 'EMPRESA'),
      breadcrumb: {
        label: 'Editando informações fiscais',
        icon: 'pi pi-fw pi-pencil'
      } as BreadCrumbRouteConfig
    }
  }
];
